import React from "react";

const NavList = () => {
    return (
        <div className="nav-con">
            <ul>
                
                <li>All friends</li>  
                <li>Recently Added</li>
                <li>Birthdays</li>
                <li>College</li>
                <li>Current City</li>
                <li>Hometown</li>
                <li>Followers</li>
                <li>Following</li>
            </ul>
            <button></button>
        </div>
    );
}

export default NavList